
import { BrowserRouter } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import routes from "./router/config";

function AppRoutes() {
  const element = useRoutes(routes);
  return element;
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
